const defaultTitles = {
  hero: 'Somos una plataforma de Art Toys, que conecta a los artistas con los coleccionistas de forma segura y directa.',
  preorders: 'Preventas',
  collaboration: {
    leadLine1: '¿Eres un artista o tienes algun art toy a la venta?',
    leadLine2: 'Escríbenos a',
    email: 'hey@bluppimart.com',
    trailing: ' Nos gustaría colaborar contigo.',
  },
};

const kioskTitles = {
  hero: '',
  preorders: 'Preventas',
  collaboration: {
  },
};

export const getHomeTitles = (isKiosk) => (isKiosk ? kioskTitles : defaultTitles);
